import { useMemo } from "react";

import type { SearchTrafficDataSchema } from "../../services/search-overview-api/types";
import type { getDomains } from "../utils";
import { transformCostPerVisit, transformPaidVisits, transformPpcSpend } from "../utils";

export const useTransformedTrafficData = (
    trafficData: SearchTrafficDataSchema,
    domains: ReturnType<typeof getDomains>,
) => {
    return useMemo(() => {
        if (!trafficData) {
            return { paidVisitsData: [], ppcSpendData: [], costPerVisitData: [] };
        }

        const paidVisitsData = transformPaidVisits(trafficData, domains) || [];
        const ppcSpendData = transformPpcSpend(trafficData, domains) || [];
        const costPerVisitData = transformCostPerVisit(trafficData, domains) || [];

        return { paidVisitsData, ppcSpendData, costPerVisitData };
    }, [trafficData, domains]);
};
